import GenericViewOffline from '../../GenericViewOffline';

export default class user_invite_help extends GenericViewOffline {
    constructor(uri, app, className, data) {
        super(uri, app, (className || 'user_invite_help'), data);
        this.auto_destroy = true;
        this.data = {data: {}}
    }
}
